/* global BigInt */
import { useSyncExternalStore } from 'react';

let muted = true;
const listeners = new Set();
export function setFeedMuted(value) {
  if (muted === value) return;
  muted = value;
  listeners.forEach(listener => listener());
}
export function useFeedMuted() {
  return useSyncExternalStore(listener => { listeners.add(listener); return () => listeners.delete(listener); }, () => muted);
}
const HISTORY_KEY = 'happytimes.seenPosts.v1';

let memoryHistory = [];
let storageUnavailable = false;
let cachedHistory = null;
const historyListeners = new Set();
function notifyHistory() { historyListeners.forEach(listener => listener()); }
function subscribeHistory(listener) {
  historyListeners.add(listener);
  const changed = event => { if (event.key === HISTORY_KEY || event.key === null) { readSeenPosts(); listener(); } };
  window.addEventListener('storage', changed);
  return () => { historyListeners.delete(listener); window.removeEventListener('storage', changed); };
}
function historySnapshot() { readSeenPosts(); return memoryHistory; }
export function useSeenPosts() { return useSyncExternalStore(subscribeHistory, historySnapshot); }
export function readSeenPosts() {
  if (storageUnavailable) return [...memoryHistory];
  try {
    const serialized = localStorage.getItem(HISTORY_KEY) || '[]';
    if (serialized !== cachedHistory) {
      const stored = JSON.parse(serialized);
      memoryHistory = Array.isArray(stored) ? [...new Set(stored.filter(id => /^\d+$/.test(String(id))).map(String))] : [];
      cachedHistory = serialized;
    }
  } catch { storageUnavailable = true; }
  return [...memoryHistory];
}
export function markPostSeen(id) {
  if (!/^\d+$/.test(String(id))) return;
  const previous = readSeenPosts();
  if (previous.includes(String(id))) return;
  memoryHistory = [...previous, String(id)];
  try { const serialized = JSON.stringify(memoryHistory); localStorage.setItem(HISTORY_KEY, serialized); cachedHistory = serialized; } catch { storageUnavailable = true; }
  notifyHistory();
}

// Consecutive post IDs become one exclusion range, without forgetting old views.
export function compactSeenPosts(ids) {
  const sorted = [...new Set(ids)].map(BigInt).sort((a,b)=>a<b?-1:a>b?1:0);
  const ranges = [];
  for (const id of sorted) {
    const last = ranges[ranges.length-1];
    if (last && id === BigInt(last[1])+BigInt(1)) last[1] = String(id);
    else ranges.push([String(id),String(id)]);
  }
  return ranges;
}
